// extracted by mini-css-extract-plugin
export default {"wrap":"CenteredColumn_wrap__b3Pyn","column":"CenteredColumn_column__xXMW1"};